import cls from 'classnames';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from "react-redux";
import { addProductsToCart, fetchUserData, setUser } from "../../redux/actions";
import { useState } from 'react';

export default function NumberInputForCart({
    min = 1,
    max = 9999,
    value,
    onChange,
    name="quantity",
    className = "gap-x-2",
    inputClassName="w-30",
    inputWrapperClassName,
    cartId,
    product_variation,
    refreshCart
  }) {
    const dispatch  =  useDispatch();
    const user_data = useSelector((state) => state?.user_data?.user_data) ?? {};
    const [isLoading, setIsLoading] = useState(false);

    const onIncrease = async () => {
        setIsLoading(true);

        let newValue = value + 1;

        if (newValue >= max) {
            newValue = max;
            toast.error("Maximum limit reached.");
        }
        onChange({ target: { value: newValue, name } });
        await updateCart(1);

        setIsLoading(false);
    };
  
    const onDecrease = async () => {
        setIsLoading(true);

        let newValue = value - 1;

        if (newValue <= min) newValue = min;
        onChange({ target: { value: newValue, name } });
        await updateCart(-1);

        setIsLoading(false);
    };
  
    const onChangeHandler = async (e) => {
        setIsLoading(true);

        let newValue = Number(e.target.value) || 1;
        if (newValue < min && newValue !== "") newValue = min;
        if (newValue > max) {
            newValue = max;
            toast.error("Maximum limit reached.");
        }
    
        const difference = newValue - value; // Calculate difference
        onChange({ target: { value: newValue, name } });

        await updateCart(difference);

        setIsLoading(false);
    };

    const updateCart = async (quantity) => {
        const data = await addProductsToCart(cartId, product_variation, quantity);
        
        if(data) {
            if(user_data?.name) {
                const user = await fetchUserData();
                if(user) {
                    dispatch(setUser(user));
                    await refreshCart();
                }     
            } else {
                await refreshCart();
            }        
        }
    }    

    return (        
        <div className={`d-flex align-items-center gap-16 ${className}`}>
            {/* <button
                type="button"
                className={cls('ph ph-minus w-40 h-40 text-xl flex-center rounded-circle', {
                    'bg-main-product-50 hover-bg-main-product-50 text-white': value > min,
                    'bg-light-grey text-white': value <= min,
                })}
                disabled={value <= min}
                onClick={onDecrease}
            /> */}
            <button
                type="button"
                className={cls('ph ph-minus w-40 h-40 text-xl flex-center rounded-circle', {
                    'bg-main-product-50 hover-bg-main-product-50 text-white': value > min && !isLoading,
                    'bg-light-grey text-white': value <= min || isLoading,
                })}
                disabled={value <= min || isLoading}
                onClick={onDecrease}
            />
    
            <div className={cls("overflow-hidden", inputWrapperClassName)}>
                <div className={cls(inputClassName)}>
                    {/* <input
                        value={value}
                        onChange={onChangeHandler}
                        className={cls("block text-center", inputClassName)}
                    /> */}
                    <input
                        value={value}
                        onChange={onChangeHandler}
                        className={cls("block text-center", inputClassName)}
                        disabled={isLoading} 
                    />
                </div>
            </div>
            <button
                type="button"
                className={cls('ph ph-plus w-40 h-40 text-xl flex-center rounded-circle', {
                    'bg-main-product-50 hover-bg-main-product-50 text-white': value < max && !isLoading,
                    'bg-light-grey text-white': value >= max || isLoading,
                })}
                disabled={value >= max || isLoading}
                onClick={onIncrease}
            />
            {/* <button
                type="button"
                className={cls('ph ph-plus w-40 h-40 text-xl flex-center rounded-circle', {
                    'bg-main-product-50 hover-bg-main-product-50 text-white': value < max,
                    'bg-light-grey text-white': value >= max
                })}
                disabled={value >= max}
                onClick={onIncrease}
            /> */}
        </div>           
    );
  }
  